<template>
  <fragment>
    <header class="ws-group-header">
      <div class="columns is-multiline">
        <div class="column is-9">
          <h1 class="ws-page-header__title has-text-weight-bold is-size-2">
            <span v-if="org.title">
              <ws-icon v-if="!org.visible" name="stop" color="red" class="icon-stop" width="20" height="20" style="margin-right: 5px"/>
              <span v-text="org.title.display"></span></span>
          </h1>
          <h3 class="has-text-weight-bold is-size-3 mt-2">
            <span>Краткое наименование: </span>
            <span v-if="org.short_title && org.short_title.translate && org.short_title.translate.ru" v-text="org.short_title.translate.ru"></span>
          </h3>

          <h3 class="has-text-weight-bold is-size-3 mt-1">
            <span>Адрес организации: </span>
            <span v-if="org.address" v-text="orgAddress"></span>
          </h3>

          <h3 class="has-text-weight-bold is-size-3 mt-1">
            <span>ИНН: </span>
            <span v-text="org.inn"></span>
            <span class="ml-1">КПП: </span>
            <span v-text="org.kpp"></span>
            <span class="ml-1">ОГРН: </span>
            <span v-text="org.ogrn"></span>
          </h3>
        </div>
        <div class="column is-3 has-text-right-desktop">
          <ws-role-node :only="['front_curator_institution', 'front_university', 'front_curator', 'front_dep', 'front_rcc', 'front_admin']">
            <button @click="updateOrgWithTicket" class="ws-button button is-primary">
              <span
                class="is-size-4 has-text-weight-bold"
                v-text="$t('Изменить данные об ОО')"
              ></span>
            </button>
          </ws-role-node>
        </div>
      </div>
    </header>
    <div class="ws-study-groups">
      <template v-if="hasPermissions">
        <section class="ws-study-groups__column">
          <header class="ws-study-groups__header">
            <div class="columns is-vcentered">
              <div class="column">
                <h2 class="title is-size-3">{{ $t('Учебные группы') }}</h2>
              </div>
              <div class="column has-text-right">
                <button
                  class="ws-button button is-text has-text-left"
                  @click="createItem"
                >
                  <ws-icon
                    class="ws-button__icon is-position-left"
                    name="plus-circle"
                    :title="$t('Добавить группу')"
                    color="#1c3b8d"
                    width="20"
                    height="20"
                  />
                  <strong
                    class="ws-button__text has-text-primary"
                    v-text="$t('Добавить группу')"
                  ></strong>
                </button>
              </div>
            </div>
            <div class="group__filter">
              <button
                v-for="year in groupYears" :key="year.education_year"
                class="ws-button button is-text has-text-left group__filter__btn"
                :class="{'group__filter__selected' : selectedYear === year.education_year}"
                @click="onFilterByYear(year)"
              >
                <strong
                  class="has-text-primary"
                  v-text="$t(`${year.education_year}/${year.education_year + 1}`)"
                ></strong>
              </button>
              <button
                v-if="list.length"
                class="ws-button button is-text has-text-left"
                @click="onFilterByYear({ education_year: 'all' })"
                :class="{'group__filter__selected' : selectedYear === 'all'}"
              >
                <strong
                  class="has-text-primary"
                  v-text="$t('Все')"
                ></strong>
              </button>
            </div>
          </header>
          <ws-list-view
            class="ws-groups-list ws-study-groups__list"
            :class="{ 'is-pending':isPending, 'is-loading':isFindPending }"
            :data="filteredPerPage"
            :header="false"
            :selected.sync="selected"
            :skeleton="isPending"
            :detailed="false"
          >
            <template slot-scope="props">
              <ws-list-view-item-column>
                <span :data-key="props.row.guid">
                  <span
                    class="has-text-weight-bold"
                    v-text="props.row.name"
                  ></span>&nbsp;
                  <span
                    v-if="props.row.education_year"
                    v-text="props.row.education_year"
                  ></span>
                  <ws-group-missing-files :guid="props.row.guid" />
                </span>
                <h4
                  class="ws-exam-groups-list__item-title"
                  v-if="props.row.edu_program"
                >
                  <span
                    class="has-text-weight-bold"
                    v-if="props.row.edu_program.code"
                  >{{ props.row.edu_program.code }}</span>&nbsp;
                  <span v-text="props.row.edu_program.title.translate.ru"></span>
                </h4>
                <ws-study-group-tags :study_group="props.row"></ws-study-group-tags>
              </ws-list-view-item-column>
              <ws-list-view-item-column>
                <span
                  class="is-block"
                  :data-participants-length="props.row.participants ? props.row.participants.length : 0"
                >
                  <ws-icon
                    class="ws-member-icon ws-button__icon"
                    name="member"
                    color="#000"
                    :fill="false"
                    width="9.75"
                    height="12.45"
                  />
                  <span>&nbsp;</span>
                  <span
                    v-if="props.row.participants"
                    v-text="participantsCount(props.row.participants)"
                  ></span>
                </span>
              </ws-list-view-item-column>
              <ws-list-view-item-column>
                <div class="is-fullwidth has-text-right">
                  <button
                    class="button is-text"
                    @click.stop="editItem(props.row)"
                    :aria-label="$t('Редактировать')"
                  >
                    <ws-icon
                      class="ws-button__icon"
                      name="edit"
                      color="#6D9AE8"
                      :fill="false"
                      width="14"
                      height="14"
                    />
                  </button>
                  <button
                    class="button is-text"
                    @click.stop="removeItem(props.row)"
                    :aria-label="$t('Удалить')"
                  >
                    <ws-icon
                      class="ws-button__icon"
                      name="trash"
                      color="#6D9AE8"
                      :fill="false"
                      width="14"
                      height="14"
                    />
                  </button>
                </div>
              </ws-list-view-item-column>
              <ws-list-view-item-column>
                <span class="is-fullwidth">
                  <span
                    class="has-text-weight-bold"
                    v-text="props.row.prof_code"
                  ></span>
                  <span>&nbsp;</span>
                  <span v-text="props.row.profession"></span>
                </span>
              </ws-list-view-item-column>
            </template>
            <template slot="skeleton">
              <ws-list-view-skeleton-item
                :height="'25px'"
                :boxCount="1"
                :boxHeights="['18px']"
              />
              <ws-list-view-skeleton-item
                :height="'25px'"
                :boxCount="1"
                :boxHeights="['18px']"
              />
              <ws-list-view-skeleton-item
                :height="'11px'"
                :boxCount="1"
                :boxHeights="['1px']"
              />
              <ws-list-view-skeleton-item
                :height="'25px'"
                :boxCount="1"
                :boxHeights="['18px']"
              />
              <ws-list-view-skeleton-item
                :height="'25px'"
                :boxCount="1"
                :boxHeights="['18px']"
              />
            </template>
            <template v-if="list.length" slot="empty">
              {{ $t('В текущем учебном году учебные группы отсутствуют') }}
            </template>
          </ws-list-view>

          <ws-pagination
            v-if="isShownPagination"
            @change="onPageChange"
            :align="'right'"
            :totalItems="filteredList.length"
            :itemsPerPage="parseInt(per_page)"
            :maxPageNumbers="6"
            :disabled="isPending"
            :currentIndex="currentPage - 1"
          >
          </ws-pagination>

          <b-loading
            :is-full-page="false"
            :active="isRemovePending"
          ></b-loading>
        </section>

        <section class="ws-participants ws-study-groups__column">
          <template v-if="currentId">
            <header class="ws-participants__header">
              <ws-search-users
                @input-users="updateGroupUsersList"
                :placeholder="$t('Введите имя участника')"
              />
            </header>
            <ws-participants-import :isDragAndDrop="true" @input-users="updateGroupUsersList" />
            <ws-participants-list @input-users="removeUsersFromGroupList" />
            <!--<footer class="ws-participants__footer has-text-right-desktop">
              <button class="ws-button button is-large is-primary">
                <span class="is-size-4 has-text-weight-bold" v-text="$t('Сохранить')"></span>
              </button>
            </footer>-->
          </template>
          <template v-else>
            <p
              class="has-text-centered"
              v-text="$t('Выберите группу')"
            ></p>
          </template>
          <b-loading
            :is-full-page="false"
            :active="isUpdatePending"
          ></b-loading>
        </section>
      </template>
      <template v-else>
        <p>{{ $t('Отсутствует доступ для просмотра учебных групп образовательной организации')}}</p>
      </template>
    </div>
  </fragment>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import listMixin from '@/mixins/list.mixin'
import WsStudyGroupForm from '@/components/de/groups/modals/WsStudyGroupForm'
import WsStudyGroupTags from '@/components/de/groups/WsStudyGroupTags'
import WsOrgsUpdateTicket from '@/components/de/orgs/modals/WsOrgsUpdateTicket'
import moment from 'moment'
import WsGroupMissingFiles from '@/components/de/groups/WsGroupMissingFiles'

const getCurrentEducationYear = () => {
  const year = moment().year()
  const month = moment().month()
  return month < 5 ? year - 1 : year
}

export default {
  name: 'WsStudyGroupsList',
  components: { WsStudyGroupTags, WsGroupMissingFiles },
  mixins: [listMixin],
  props: {
    org: Object
  },
  data () {
    const query = this.$route.query
    return {
      list: [],
      per_page: 10,
      hasPermissions: true,
      selected: null,
      selectedYear: 'guid_group' in query ? 'all' : getCurrentEducationYear(),
      currentYear: getCurrentEducationYear(),
      currentPage: 1
    }
  },
  computed: {
    isShownPagination () {
      return this.filteredList.length > this.per_page
    },
    getEducationGuid () {
      return this.$route.params.id
    },
    ...mapState('refbook/study_groups', {
      isFindPending: 'isFindPending',
      isRemovePending: 'isRemovePending',
      isUpdatePending: 'isUpdatePending',
      currentId: 'currentId',
      pagination: 'pagination'
    }),
    isPending () {
      return this.isFindPending && (this.list && this.list.length === 0)
    },
    groupYears () {
      return (this.list && this.list.length) ? [...this.list, { education_year: this.currentYear }].filter((i, ind, arr) => arr.findIndex(j => j.education_year === i.education_year) === ind)
        .sort((a, b) => a.education_year - b.education_year) : []
    },
    filteredList () {
      if (this.selectedYear === 'all') return this.list || []
      return this.list ? this.list.filter(i => i.education_year === this.selectedYear) : []
    },
    filteredPerPage () {
      return this.filteredList.slice((this.currentPage - 1) * parseInt(this.per_page), parseInt(this.per_page) * this.currentPage)
    },
    orgAddress () {
      const address = this.org.address.address && this.org.address.address.translate && this.org.address.address.translate.ru
      const locality = this.org.address.locality && this.org.address.locality.title && this.org.address.locality.title.translate && this.org.address.locality.title.translate.ru
      const region = this.org.address.region && this.org.address.region.title && this.org.address.region.title.translate && this.org.address.region.title.translate.ru
      return `${region ? region + ',' : ''} ${locality ? locality + ',' : ''} ${address || ''}`
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler (item) {
        this.setCurrent(item)
      }
    }
  },
  methods: {
    ...mapActions('refbook/study_groups', ['find', 'remove', 'update']),
    ...mapMutations('refbook/study_groups', ['clearAll', 'setCurrent']),
    ...mapActions('public/refbook/education/institution', {
      'findInstitution': 'find'
    }),
    participantsCount (participants) {
      const _participants = participants.filter(item => {
        return item
      }).reduce((x, y) => x.findIndex(e => e.guid === y.guid) < 0 ? [...x, y] : x, [])

      return _participants.length || 0
    },
    onPageChange (pagination) {
      this.currentPage = pagination.page + 1
      this.per_page = pagination.per_page
      // this.pushState()
      // this._fetch()
      window.scrollTo(0, 0)
    },
    onFilterByYear (year) {
      this.currentPage = 1
      this.selectedYear = year.education_year
    },
    removeItem (item) {
      if (item) {
        this.$buefy.dialog.confirm({
          title: this.$t(`Вы действительно хотите удалить группу «${item.name}»?`),
          cancelText: this.$t('Отмена'),
          confirmText: this.$t('Удалить'),
          type: 'is-danger',
          onConfirm: async () => {
            try {
              await this.remove(item.guid)
              this.list.splice(this.list.findIndex(i => i.guid === item.guid), 1)
            } catch (e) {
              if (e.status_code === 404) {
                this.$buefy.dialog.alert({
                  title: this.$t('Удаление запрещено'),
                  type: 'is-danger',
                  message: this.$t(`Вы не можете удалить учебную группу «${item.name}», так как она добавлена в демонстрационный экзамен.`),
                  confirmText: this.$t('Ок')
                })
              }
            }
            //
          }
        })
      }
    },
    async createItem () {
      this.$buefy.modal.open({
        parent: this,
        component: WsStudyGroupForm,
        width: 1200,
        hasModalCard: true,
        props: {
          educationGuid: this.getEducationGuid,
          is_in_prof_cluster: this.org.is_in_prof_cluster
        },
        canCancel: false,
        events: {
          'createGroup': async group => {
            await this._fetch()
          }
        }
      })
    },
    async updateOrgWithTicket () {
      this.$buefy.modal.open({
        parent: this,
        component: WsOrgsUpdateTicket,
        width: 930,
        hasModalCard: true,
        props: {
          data: this.org
        },
        canCancel: false,
        events: {
          'fetch': async group => {
            await this._fetch()
          }
        }
      })
    },
    editItem (item) {
      if (item) {
        this.$buefy.modal.open({
          parent: this,
          component: WsStudyGroupForm,
          width: 1200,
          hasModalCard: true,
          props: {
            educationGuid: this.getEducationGuid,
            is_in_prof_cluster: this.org.is_in_prof_cluster,
            item: JSON.parse(JSON.stringify(item))
          },
          canCancel: false,
          events: {
            'updateGroup': async () => {
              this.list = []
              await this._fetch()
            }
          }
        })
      }
    },
    async updateGroupUsersList (users) {
      if (users && users.length) {
        try {
          await this.update([this.selected.guid, {
            update: [
              ...users.map(user => user.guid)
            ]
          }, '/participants'])
          await this._fetch()
        } catch (e) {

        }
      }
    },
    async removeUsersFromGroupList (users) {
      if (users) {
        this.$buefy.dialog.confirm({
          title: this.$t(`Вы действительно хотите удалить участника из группы?`),
          cancelText: this.$t('Отмена'),
          confirmText: this.$t('Удалить'),
          type: 'is-danger',
          onConfirm: async () => {
            try {
              await this.update([this.selected.guid, {
                delete: [
                  ...users.map(user => user.guid)
                ]
              }, '/participants'])
              await this._fetch()
            } catch (e) {
              if (e.status_code === 404 || e.status_code === 500) {
                this.$buefy.dialog.alert({
                  title: this.$t('Удаление запрещено'),
                  type: 'is-danger',
                  message: this.$t(`Участник учебной группы добавлен в демонстрационный экзамен.`),
                  confirmText: this.$t('Ок')
                })
              }
            }
          }
        })
      }
    },

    async _fetch () {
      try {
        this.clearAll()
        this.setCurrent(this.selected && this.selected.guid)

        const orgs = await this.findInstitution({
          query: { ids: this.getEducationGuid }
        })
        if (orgs && orgs.length === 0) {
          this.hasPermissions = false
        } else {
          this.list = await this.find({ query: {
            education_guid: this.getEducationGuid,
            page: 1,
            per_page: 300000
          } })
          const query = this.$route.query
          if (query['guid_group']) {
            this.selected = this.list.find((el) => el.guid === query['guid_group'])
            this.$nextTick(() => {
              const scrollEl = document.querySelector(`[data-key="${query['guid_group']}"]`)
              scrollEl.scrollIntoView()
            })
          }
          if (!this.list) this.list = []
        }
      } catch (e) {
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так. Попробуйте еще раз`),
          type: 'is-danger'
        })
      }
    }
  },
  created () {
    this._fetch()
  }
}
</script>
<style lang="scss" scoped>
.ws-groups-list {
  margin-bottom: 20px;
}
.ws-pagination {
  margin-right: 20px;
  margin-bottom: 20px;
}
.mt-2 {
  margin-top: 1.5rem;
}
.mt-1 {
  margin-top: 1rem;
}
.ml-1 {
  margin-left: 1rem;
}
.group__filter {
  margin-top: -1.2rem;
  &__selected {
    text-decoration: underline;
  }

  &__btn {
    margin-right: 0.5rem;
  }
}
.ws-group-header {
  margin-bottom: 20px;
}
</style>
